// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3EFUR","row":"styles_row__2GTct"};